<!-- @format -->

<template>
	<pcp-mo-image-upload
		v-model="value"
		:limit="pcProps.maxUpLength"
		:file-size="pcProps.maxSize"
		:file-type="fileType"
		:accept="pcProps.acceptVideo || 'video/*'"
		:readonly="disabled"
		:deletable="!disabled"
		:show-upload="!disabled"
	/>
</template>

<script setup lang="ts">
	import { type WidgetConfigType } from '../../types';
	import { PcpMoImageUpload } from '@/p-components';

	interface Props {
		modelValue: any;
		pcProps: WidgetConfigType;
		disabled?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: '',
	});

	const emit = defineEmits(['update:modelValue']);

	const fileType = computed(() => (props.pcProps.acceptVideo ? props.pcProps.acceptVideo.split(',') : []));

	const value = computed({
		get() {
			return Array.isArray(props.modelValue) ? props.modelValue.join(',') : props.modelValue;
		},
		set(val) {
			emit('update:modelValue', val);
		},
	});
</script>

<style scoped lang="scss"></style>
